import { render } from "./CategoryFilterBody.vue?vue&type=template&id=45416bac"
import script from "./CategoryFilterBody.vue?vue&type=script&lang=js"
export * from "./CategoryFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__